/**
 * Mirrors the API's readiness rule (core `templates.ts`): nothing generates
 * until the category briefing exists and every non-manual stage has its own
 * instructions. Kept out of api.ts so it stays real in tests that mock the
 * API client — it is a rule, not a request.
 */
import type { KnowledgeTemplate } from './api.js';

export const templateReadiness = (t: KnowledgeTemplate): { ready: boolean; missing: string[] } => {
  const missing: string[] = [];
  if (t.promptContext.trim().length === 0) missing.push('a category briefing');
  if (t.list.mode !== 'MANUAL' && t.list.prompt.trim().length === 0) {
    missing.push('instructions for step 1');
  }
  if (t.item.mode !== 'MANUAL' && t.item.prompt.trim().length === 0) {
    missing.push('instructions for step 2');
  }
  return { ready: missing.length === 0, missing };
};
